import React, { useEffect, useState } from 'react';
import { Offcanvas } from "react-bootstrap";
import { Stepper } from 'react-form-stepper';
import { Form } from 'react-bootstrap';
import StepOne from './edit/StepOne';
import StepTwo from './edit/StepTwo';
import StepThree from './edit/StepThree';
import StepFour from './edit/StepFour';
import StepFive from './edit/StepFive';
import StepSix from './edit/StepSix';
import StepSeven from './edit/StepSeven';
import StepEight from './edit/StepEight';
import StepNine from './edit/StepNine';
import StepTen from './edit/StepTen';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { useGetApplicationQuery } from '../../redux/services/ApplicationService';
import GlobalLoading from '../../components/GlobalLoading';

const EditApplication = () => {
    const params = useParams()
    const navigation = useNavigate();
    const [isEdits, setIsEdit] = useState(null)

    const { data, isLoading } = useGetApplicationQuery(params)
    const isEdit = data?.response?.data





    // useEffect(() => {
    //     if (data?.response?.data) {
    //         setIsEdit(data?.response?.data)
    //         console.log(data?.response?.data, 'data')
    //     }
    //     return () => {
    //         setIsEdit(null)
    //     }
    // }, [data?.response?.data])





    const [activeStep, setActiveStep] = useState(0);
    const stepForm = [
        {
            id: 1,
            component: (
                <StepOne
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    params={params}
                    isEdit={isEdit}
                    setIsEdit={setIsEdit}
                />
            ),
        },
        {
            id: 2,
            component: (
                <StepTwo
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    params={params}
                    isEdit={isEdit}
                    setIsEdit={setIsEdit}
                />
            ),
        },
        {
            id: 3,
            component: (
                <StepThree
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    params={params}
                    isEdit={isEdit}
                    setIsEdit={setIsEdit}
                />
            ),
        },
        {
            id: 4,
            component: (
                <StepFour activeStep={activeStep} setActiveStep={setActiveStep} params={params} isEdit={isEdit} setIsEdit={setIsEdit} />
            ),
        },
        {
            id: 5,
            component: (
                <StepFive activeStep={activeStep} setActiveStep={setActiveStep} params={params} isEdit={isEdit} setIsEdit={setIsEdit} />
            ),
        },
        {
            id: 6,
            component: (
                <StepSix activeStep={activeStep} setActiveStep={setActiveStep} params={params} isEdit={isEdit} setIsEdit={setIsEdit} />
            ),
        },
        {
            id: 7,
            component: (
                <StepSeven activeStep={activeStep} setActiveStep={setActiveStep} params={params} isEdit={isEdit} setIsEdit={setIsEdit} />
            ),
        },
        {
            id: 8,
            component: (
                <StepEight activeStep={activeStep} setActiveStep={setActiveStep} params={params} isEdit={isEdit} setIsEdit={setIsEdit} />
            ),
        },
        {
            id: 9,
            component: (
                <StepNine activeStep={activeStep} setActiveStep={setActiveStep} params={params} isEdit={isEdit} setIsEdit={setIsEdit} />
            ),
        },
        {
            id: 10,
            component: (
                <StepTen activeStep={activeStep} setActiveStep={setActiveStep} params={params} isEdit={isEdit} setIsEdit={setIsEdit} />
            ),
        },
        // { id: 4, component: <StepOne activeStep={activeStep} /> },
    ];
    return (
        <>
            {isEdit?.is_application_editable == 0 ? <Navigate to={`/application/view/${params?.systemID}/${params?.driverId}`} replace={true} /> : (
                <>
                    <div className="canvas-lg bg-light py-5" placement="end">

                        <div className="top-bar text-center">
                            <Offcanvas.Title>
                                Driver Application
                            </Offcanvas.Title>
                        </div>

                        {(isLoading) ? <GlobalLoading /> : (
                            <>
                                {isEdit && (
                                    <Offcanvas.Body>
                                        <Stepper
                                            steps={[{ label: 'Personal Info' }, { label: "Driver's License Info" }, { label: 'Drug Test Info' }, { label: 'Pre-Employment Info' }, { label: 'Social Security Info' }, { label: 'MVR' }, { label: 'Consent & Legal Agreements' }, { label: 'Optional Uploads' }, { label: 'Emergency Contact' }, { label: 'DOT Physical Exam' }]}
                                            styleConfig={{
                                                activeBgColor: "#f56600",
                                                activeTextColor: "#fff",
                                                inactiveBgColor: "#fff",
                                                inactiveTextColor: "#999",
                                                completedBgColor: "#201f43",
                                                completedTextColor: "#fff",
                                                size: "2em",
                                                fontWeight: "bold",
                                            }}
                                            activeStep={activeStep}
                                        />
                                        {stepForm[activeStep].component}

                                    </Offcanvas.Body>
                                )}
                            </>
                        )}


                    </div>
                </>
            )}
        </>
    );
};

export default EditApplication;